


export function getBy56Api(env) {
    const By56ApiList = {
        dev14: {
            // 本地调试配置  78 17 14
            api01: "https://ICI14.by56.com", //信息库-产品库
            api02: "https://ICE14.by56.com", //基础库
            api03: "https://ICT14.by56.com",  // 交易库
            api05: "https://print.by56.com",
            api04: "https://gateway13.by56.com", // 微服务https
            apiAll: "https://front14.by56.com/",//"http://front17.by56.com/", //去老页面
            apiAir: "https://cps14.by56.com/", //去新页面
            apiSSO: "https://test.by56.com:8832/", // 第三方绑定回调
            nuxtPage: "https://seo14.by56.com/", //去NUXT页面http://seo17.by56.com/
            apiAll03: "https://test14.by56.com:8080/",  //去供应商注册页面
            apiIse: 'https://ise14.by56.com',
            apiIMCh: "https://msgstest.qusongyi.com/", //调用IM-Iform页面地址
            apiFileCloud: 'https://test-res.by56.com/', // 服务端图片显示以及文件下载前置域名
            apiFileCloudFirst: 'uploadtest' // 服务端图片显示以及文件下载根目录
        },
        dev: {
            // 本地调试配置  78 17 14
            api01: "https://ICI17.by56.com", //信息库-产品库
            api02: "https://ICE17.by56.com", //基础库
            api03: "https://ICT17.by56.com",  // 交易库
            api05: "https://print17.by56.com",
            api04: "https://gateway13.by56.com", // 微服务https
            apiAll: "https://front17.by56.com/",//"http://front17.by56.com/", //去老页面
            apiAir: "http://cps17.by56.com/", //去新页面
            apiSSO: "https://test.by56.com:8832/", // 第三方绑定回调
            nuxtPage: "http://seo13.by56.com/", //去NUXT页面http://seo17.by56.com/
            apiAll03: "https://test17.by56.com:8080/",  //去供应商注册页面
            apiIse: 'https://ise17.by56.com',
            apiIMCh: "https://im-test.by56.com/", //调用IM-Iform页面地址
            mobilePage: 'http://192.168.1.17:9202/',
            apiFileCloud: 'https://test-res.by56.com/', // 服务端图片显示以及文件下载前置域名
            apiFileCloudFirst: 'uploadtest' // 服务端图片显示以及文件下载根目录
        },
        test: {
            // 本地调试配置  沙箱
            api01: "https://icisb.by56.com", //信息库-产品库
            api02: "https://icesb.by56.com", //基础库
            api03: "https://ictsb.by56.com",  // 交易库
            api05: "https://printsb.by56.com",
            api04: "https://gatewaysb.by56.com", // 微服务
            apiAll: "https://csb.by56.com/", //去老页面
            apiAir: "https://cosb.by56.com/", //去新页面
            apiSSO: "https://cosb.by56.com/", // 第三方绑定回调
            nuxtPage: "https://sb.by56.com/", //去NUXT页面
            apiAll03: "https://test18.by56.com:8080/",  //去供应商注册页面
            apiIse: 'https://ise18.by56.com',
            apiIMCh: "https://msgstest.qusongyi.com/", //调用IM-Iform页面地址
            mobilePage: 'http://192.168.1.18:9202/',
            apiFileCloud: 'https://test-res.by56.com/', // 服务端图片显示以及文件下载前置域名
            apiFileCloudFirst: 'uploadtest' // 服务端图片显示以及文件下载根目录
        },
        prod: {
            //本地调试配置  正式
            api01: "https://ICI.by56.com", //信息库-产品库
            api02: "https://ICE.by56.com", //基础库
            api03: "https://ICT.by56.com",  // 交易库
            api04: "https://biz-api.by56.com", // 微服务
            api05: "https://print.by56.com",
            apiAll: "https://c.by56.com/", //去老页面
            apiAir: "https://co.by56.com/", //去新页面
            apiSSO: "https://co.by56.com/", // 第三方绑定回调
            nuxtPage: "https://www.by56.com/", //去NUXT页面
            apiAll03: "https://vendor.by56.com/",  //去供应商注册页面
            apiIMCh: "https://im.by56.com/", //调用IM-Iform页面地址
            apiIse: 'https://ise.by56.com',
            mobilePage: 'https://m.by56.com/',
            apiFileCloud: 'https://res.by56.com/', // 服务端图片显示以及文件下载前置域名
            apiFileCloudFirst: 'upload' // 服务端图片显示以及文件下载根目录
        },
    };
    // 通过环境变量来区分
    return By56ApiList[env];
}

